// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
	apiKey:`${process.env.REACT_APP_API_KEY}`,
	authDomain: `${process.env.REACT_APP_authDomain}`,
	projectId: `${process.env.REACT_APP_projectId}`,
	storageBucket: `${process.env.REACT_APP_storageBucket}`,
	messagingSenderId: `${process.env.REACT_APP_messagingSenderId}`,
	appId: `${process.env.REACT_APP_appId}`,
	measurementId: `${process.env.REACT_APP_measurementId}`
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const no_wa = '5540722582';
